<template>
  <div class="c-listbody">
    <div v-for="(item, index) in cardGroupMount" :key="index" class="c-listbody--wrapper">
      <ul>
        <li v-for="(card, cardIndex) in cardBlocks(index)" :key="cardIndex">
          <common-property-card :propdata="card.fields" :isFavorite="true" :mode="mode" />
        </li>
      </ul>
      <div v-if="index === 0" class="c-banner">
        <div>
          <p class="c-banner__title">☆をクリックしてお気に入り登録！</p>
          <p class="c-banner__text">
            お気に入り登録すると…<br>
              ・TOPページで価格変更通知が受け取れる！<br>
              ・いつでも自分のお気に入り物件が確認できる！
          </p>
        </div>
      </div>
      <div v-if="cardGroupMount !== item && index % 2 !== 0 && $route.params.city" class="c-listbody--ad">
        <common-property-ad v-if="adlist.length >  0" :adlist="adlist" />
      </div>
    </div>
    <common-pager
        :update="update"
        :size="size"
        :page="page"
        :count="count"
      />
  </div>
</template>

<script>
import CommonPropertyCard from '@/components/parts/CommonPropertyCard';
import CommonPropertyAd from '@/components/parts/CommonPropertyAd';
import MixinAPIs from '@/plugins/mixin-api';
import CommonPager from '@/components/common/Pager';

export default {
  name: 'SearchListBody',
  props: ['proplist', 'update', 'size', 'page', 'count', 'mode'],
  mixins: [MixinAPIs],
  components: {
    CommonPropertyCard,
    CommonPropertyAd,
    CommonPager,
  },
  data() {
    return {
      url: '',
      adlist: [],
    };
  },
  computed: {
    cardGroupMount() {
      return Math.ceil(this.proplist.length / 2);
    },
  },
  async created() {
    const temp = await this.getRPList(this.$route.params.city);
    this.adlist = temp.data.contents;
  },
  methods: {
    cardBlocks(startIndex) {
      const tmp = this.proplist.concat();
      return tmp.slice(startIndex * 2, (startIndex * 2) + 2);
    },

  },
};

</script>

<style scoped lang="scss">
* {
  font-size: 14px;
}
.c-listbody {
  &--wrapper {
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: calc(50% - 5px);
        margin: 10px 0px;
      }
      li:nth-child(odd) {
        margin-left:0;
      }
      li:nth-child(even) {
        margin-right:0;
      }
    }
  }
}

.c-banner {
  display: flex;
  justify-content: center;
  padding: 23px;
  margin: 20px 0;
  border: 1px solid #EFEFEF;
  border-radius: 20px;
  background: #fff;

  &__title {
    margin-bottom: 17px;
    color: #E83532;
    font-size: 18px;
    font-weight: bold;
  }
  &__text {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.5;
  }
}
@media screen and (max-width: 767px) {
  .c-listbody--wrapper ul li {
    width: 100%;
  }
  .c-banner {
    display: block;
    &__title {
      font-size: 16px;
    }
  }
}
</style>
